import * as Sentry from '@sentry/react'

import type { UserInfo } from '@/client/types.gen'
import { isSentrySendPiiEnabled, isSentryUserFeedbackAvailable } from '@/services/sentry'

function buildFeedbackMessage(requestedLanguage: string, description: string): string {
	const lines = [
		'## feedback_type: language_request',
		`## requested_language: ${requestedLanguage.trim()}`,
		'## context: analysis_output',
	]
	const trimmedDescription = description.trim()
	if (trimmedDescription) {
		lines.push(`## description: ${trimmedDescription}`)
	}
	return lines.join('\n')
}

function resolveFeedbackUserIdentity(user?: UserInfo | null): { name?: string; email?: string } {
	if (!isSentrySendPiiEnabled() || !user) {
		return {}
	}

	const name = [user.firstname, user.lastname].filter(Boolean).join(' ') || undefined
	const email = user.email ?? undefined
	return { name, email }
}

export function submitAnalysisLanguageRequestFeedback(
	requestedLanguage: string,
	description: string,
	user?: UserInfo | null
): string | undefined {
	if (!isSentryUserFeedbackAvailable()) {
		return undefined
	}

	const trimmedLanguage = requestedLanguage.trim()
	if (!trimmedLanguage) {
		return undefined
	}

	const { name, email } = resolveFeedbackUserIdentity(user)

	return Sentry.captureFeedback({
		message: buildFeedbackMessage(trimmedLanguage, description),
		...(name ? { name } : {}),
		...(email ? { email } : {}),
		url: window.location.href,
		source: 'language-request',
		tags: {
			feedback_source: 'language-request',
			feedback_type: 'language_request',
			request_context: 'analysis_output',
		},
	})
}
